var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #e63030;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EMI"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.83,35.86c0,4.47-3.62,8.09-8.09,8.09s-8.07-3.62-8.07-8.09,3.62-8.07,8.07-8.07,8.09,3.62,8.09,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.45,26.17V8.12c0-1.14-.93-2.05-2.07-2.05h-1.93v-1.63c0-.85-.71-1.56-1.56-1.56h-1.73c-.85,0-1.56.71-1.56,1.56v1.63h-5v-1.63c0-.85-.71-1.56-1.59-1.56h-1.71c-.87,0-1.56.71-1.56,1.56v1.63h-5.02v-1.63c0-.85-.71-1.56-1.56-1.56h-1.73c-.85,0-1.56.71-1.56,1.56v1.63h-5v-1.63c0-.85-.71-1.56-1.59-1.56h-1.71c-.87,0-1.56.71-1.56,1.56v1.63h-1.95c-1.14,0-2.05.91-2.05,2.05v32.31c0,1.14.91,2.05,2.05,2.05h25.61c2.05,2.8,5.36,4.63,9.08,4.63,6.22,0,11.26-5.04,11.26-11.26,0-4.13-2.24-7.72-5.55-9.69ZM2.5,12.7v-4.57c0-.3.24-.55.55-.55h1.95v1.63c0,.85.69,1.56,1.56,1.56h1.71c.87,0,1.59-.71,1.59-1.56v-1.63h5v1.63c0,.85.71,1.56,1.56,1.56h1.73c.85,0,1.56-.71,1.56-1.56v-1.63h5.02v1.63c0,.85.69,1.56,1.56,1.56h1.71c.87,0,1.59-.71,1.59-1.56v-1.63h5v1.63c0,.85.71,1.56,1.56,1.56h1.73c.85,0,1.56-.71,1.56-1.56v-1.63h1.93c.3,0,.57.24.57.55v4.57H2.5ZM37.74,45.62c-5.36,0-9.73-4.37-9.73-9.75s4.37-9.73,9.73-9.73,9.75,4.37,9.75,9.73-4.37,9.75-9.75,9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.83,35.86c0,4.47-3.62,8.09-8.09,8.09s-8.07-3.62-8.07-8.09,3.62-8.07,8.07-8.07,8.09,3.62,8.09,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.83,35.86c0,4.47-3.62,8.09-8.09,8.09s-8.07-3.62-8.07-8.09,3.62-8.07,8.07-8.07,8.09,3.62,8.09,8.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.44,16.85h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM23.68,21.28h-2.92v-2.92h2.92v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.68,16.85h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM30.93,21.28h-2.92v-2.92h2.92v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.93,16.85h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM38.18,21.28h-2.92v-2.92h2.92v2.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.94,24.62h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM9.18,29.05h-2.92v-2.92h2.92v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.19,24.62h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM16.43,29.05h-2.92v-2.92h2.92v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.44,24.62h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM23.68,29.05h-2.92v-2.92h2.92v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.94,32.4h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM9.18,36.82h-2.92v-2.92h2.92v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.19,32.4h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM16.43,36.82h-2.92v-2.92h2.92v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.44,32.4h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM23.68,36.82h-2.92v-2.92h2.92v2.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.19,16.85h-4.43c-.42,0-.75.34-.75.75v4.43c0,.42.34.75.75.75h4.43c.42,0,.75-.34.75-.75v-4.43c0-.42-.34-.75-.75-.75ZM16.43,21.28h-2.92v-2.92h2.92v2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.68,17.71c.3.29.3.77,0,1.06l-3.11,3.14c-.15.15-.34.22-.53.22s-.38-.07-.53-.21l-1.74-1.69c-.3-.29-.3-.77-.01-1.06.29-.3.77-.3,1.06-.01l1.2,1.17,2.59-2.61c.29-.29.77-.3,1.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.23,35.16c-.14,1.08-1,1.74-2.21,1.81.78.81,1.68,1.88,2.54,2.95h-1.44c-.72-.88-1.55-1.86-2.48-2.86v-.91h.64c1.03,0,1.57-.4,1.68-1h-2.32v-.66h2.27c-.16-.49-.65-.77-1.48-.77h-.79v-.94h4.79v.66h-1.73c.27.25.45.6.52,1.05h1.22v.66h-1.22Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 50,
    height: 50
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmi);
export default __webpack_public_path__ + "static/media/emi.bae7aaa57346c0a6540920a5290b2e1c.svg";
export { ForwardRef as ReactComponent };